module.exports = __webpack_public_path__ + "img/bmw_thumbnail.5093fb5e.png";